import React from "react";
import {
  ThemeProvider as MuiThemeProvider,
  StyledEngineProvider,
  adaptV4Theme,
} from "@mui/material/styles";
import { ThemeProvider } from "styled-components";
import { connect } from "react-redux";
import {
  HIGHLIGHT_COLOR_ORANGE,
  HIGHLIGHT_COLOR_BLACK,
  HIGHLIGHT_COLOR_WHITE,
  HIGHLIGHT_COLOR_DARK_GREY,
  HIGHLIGHT_COLOR_DARK_BLUE,
  HIGHLIGHT_COLOR_LIGHT_BLUE,
  LIGHT_THEME,
  DARK_THEME,
} from "../../redux/constants";
import { createTheme } from "../index";
import {
  addThemeBodyClass,
  getHighlightColor,
  getThemeClass,
  refreshThemeBodyClass,
} from "../../common/shared";

const DarkVariant = React.lazy(() => import("./DarkVariant"));
const LightVariant = React.lazy(() => import("./LightVariant"));
const ThemeBlack = React.lazy(() => import("./ThemeBlack"));
const ThemeDarkBlue = React.lazy(() => import("./ThemeDarkBlue"));
const ThemeDarkGrey = React.lazy(() => import("./ThemeDarkGrey"));
const ThemeLightBlue = React.lazy(() => import("./ThemeLightBlue"));
const ThemeOrange = React.lazy(() => import("./ThemeOrange"));
const ThemeWhite = React.lazy(() => import("./ThemeWhite"));

const ThemeLoader = (props) => {
  const primaryColor = getHighlightColor(props.highlightColor);

  const theme = createTheme(primaryColor, true);

  const className = getThemeClass(props.highlightColor, props.displayMode);

  refreshThemeBodyClass(props.highlightColor);
  addThemeBodyClass(props.highlightColor);

  return (
    <StyledEngineProvider injectFirst>
      <MuiThemeProvider theme={theme}>
        {(props.highlightColor === HIGHLIGHT_COLOR_LIGHT_BLUE ||
          props.highlightColor === null) && <ThemeLightBlue />}
        {props.highlightColor === HIGHLIGHT_COLOR_DARK_BLUE && (
          <ThemeDarkBlue />
        )}
        {props.highlightColor === HIGHLIGHT_COLOR_DARK_GREY && (
          <ThemeDarkGrey />
        )}
        {props.highlightColor === HIGHLIGHT_COLOR_WHITE && <ThemeWhite />}

        {props.highlightColor === HIGHLIGHT_COLOR_BLACK && <ThemeBlack />}
        {props.highlightColor === HIGHLIGHT_COLOR_ORANGE && <ThemeOrange />}
        {props.displayMode === LIGHT_THEME && <LightVariant />}
        {props.displayMode === DARK_THEME && <DarkVariant />}
        <ThemeProvider theme={theme}>
          <div className={`app ${className}`}>{props.children}</div>
        </ThemeProvider>
      </MuiThemeProvider>
    </StyledEngineProvider>
  );
};

const mapStateToProps = (state) => {
  return {
    displayMode: state.uxStateReducer.getIn(["appearance", "displayMode"]),
    highlightColor: state.uxStateReducer.getIn([
      "appearance",
      "highlightColor",
    ]),
  };
};

export default connect(mapStateToProps, null)(ThemeLoader);
